<template>
    <div class="resources" role="main">
      <vue-headful 
        title="Resources | Goodyear SightLine" 
        url="https://www.goodyearsightline.com/resources" 
        description="Access documentation and resources for Goodyear SightLine"
      />
  
      <div class="resources-container">
        <!-- Hero Section -->
        <section class="intro-section" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
          <b-container>
            <h1 class="wf-head">Resources</h1>
            <h2>Explore our latest insights and developments</h2>
          </b-container>
        </section>

        <!-- Statement Section -->
        <section class="statement-section" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
        <b-row>
          <b-col sm="12" md="10" offset-md="1" lg="6" offset-lg="3">
            <!--<h2 class="text-center">Expert publications, interactive value creation simulators, and Goodyear Sightline latest news. Keeping you informed, inspired, and equipped for smarter, opportunity-driven decisions.</h2>-->
          </b-col>
        </b-row>          
      </section>

      <!-- Publications Section -->
      <b-container class="more-details" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
        <section class="documents-section details-section">       
          <b-row>
            <b-col sm="12" md="12" lg="12">
              <h2>Publications</h2>
            </b-col>
          </b-row>    
        </section>

        <!-- Publication Item with box styling -->
         <section class="publication-item">
          <div class="publication-box">
            <div class="publication-content">
              <div class="publication-left">
                <img class="icon" src="@/assets/images/icons/download-pdf.png" alt="Download Content Icon" />
              </div>
              <div class="publication-middle">
                <h3>Tire-Mounted Sensor</h3>      
                <p class="publication-date">White Paper Mar 2025</p>
              </div>
              <div class="publication-right">
                <p class="publication-description">Goodyear SightLine uses tire-mounted sensors and data analytics to transform tires into an intelligent, connected system. By providing real-time insights on tire and road conditions, it improves vehicle safety, performance, and efficiency.</p>
              </div>
              <div class="publication-action">
                <a href="/resources/gysl-tire-mounted-sensor_2026.pdf" class="btn gy-primary" download="gysl-tire-mounted-sensor_2026.pdf" target="_blank" rel="noopener noreferrer">PDF Download</a>
              </div>
            </div>
          </div>
        </section>

        <section class="publication-item">
          <div class="publication-box">
            <div class="publication-content">
              <div class="publication-left">
                <img class="icon" src="@/assets/images/icons/download-pdf.png" alt="Download Content Icon" />
              </div>
              <div class="publication-middle">
                <h3>Friction Estimation</h3>      
                <p class="publication-date">White Paper Dec 2025</p>
              </div>
              <div class="publication-right">
                <p class="publication-description">Goodyear SightLine Friction Estimation provides real-time tire-road friction insights, enabling OEMs to enhance safety systems and unlock next-generation autonomous and connected vehicle capabilities.</p>
              </div>
              <div class="publication-action">
                <a href="/resources/gysl-friction-estimation-2025a.pdf" class="btn gy-primary" download="gysl-friction-estimation-2025a.pdf" target="_blank" rel="noopener noreferrer">PDF Download</a>
              </div>
            </div>
          </div>
        </section>

        <section class="publication-item">
          <div class="publication-box">
            <div class="publication-content">
              <div class="publication-left">
                <img class="icon" src="@/assets/images/icons/download-pdf.png" alt="Download Content Icon" />
              </div>
              <div class="publication-middle">
                <h3>Virtual Calibration</h3>      
                <p class="publication-date">White Paper Jul 2025</p>
              </div>
              <div class="publication-right">
                <p class="publication-description">Goodyear SightLine's Virtual Calibration, a scalable and cost-efficient approach to developing tire intelligence algorithms using simulation and data-driven methods.</p>
              </div>
              <div class="publication-action">
                <a href="/resources/gysl-virtual-calibration-2025.pdf" class="btn gy-primary" download="gysl-virtual-calibration-2025.pdf" target="_blank" rel="noopener noreferrer">PDF Download</a>
              </div>
            </div>
          </div>
        </section>

        <section class="publication-item">
          <div class="publication-box">
            <div class="publication-content">
              <div class="publication-left">
                <img class="icon" src="@/assets/images/icons/download-pdf.png" alt="Download Content Icon" />
              </div>
              <div class="publication-middle">
                <h3>Software Defined Vehicle</h3>      
                <p class="publication-date">White Paper Dec 2024</p>
              </div>
              <div class="publication-right">
                <p class="publication-description">Goodyear SightLine, a smart tire solution using AI and sensor fusion to boost vehicle safety, performance, and maintenance in software-defined vehicles.</p>
              </div>
              <div class="publication-action">
                <a href="/resources/gysl-software-defined-vehicle-2024.pdf" class="btn gy-primary" download="gysl-software-defined-vehicle-2024.pdf" target="_blank" rel="noopener noreferrer">PDF Download</a>
              </div>
            </div>
          </div>
        </section>
        </b-container>
        <div class="gy-separator"></div>
      
      <Contact/>
    </div>
  </div>
</template>
  
<script>
import Contact from './Shared/Contact'
export default {
  name: 'Resources',
  components: {
    Contact
  }
}
</script>
  
  <style scoped>
  .resources-container {
    background-color: #f2f2f2;
  }
  h1 {
    padding-top: 100px;
  }
  h2 {
    font-size: 2.0rem;
  }
  h3 {
    font-size: 1.5rem;
  }
  h4 {
    font-size: 1.25rem;
  }
  section {
    margin-bottom: 35px;
  }
  .container.more-details {
    background-color: #fff;
    padding-bottom: 10px;
    margin-bottom: 30px;
  }
  .intro-section, .details-section {
    padding-left: 15px;
    padding-right: 15px;
  }
  .intro-section {
    text-align: center;
    color: #fff;
    min-height: 550px;
    background-image: url('../assets/images/background/snowy-road.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .intro-section h1 {
    margin: 0 auto;
  }
  .intro-section h2 {
    margin: 0 auto;
  }
  .intro-section .btn {
    margin: 10px 20px;
  }
  .details-section .container {
    padding-left: 30px;
  }
  .details-section .buttons {
    margin-top: 45px;
    margin-bottom: 20px;
  }
  .statement-section h2 {
    font-size: 28px;
  }
  .driver-exp-section {
    padding-top: 20px;
  }
  .eco-opt-eff-section {
    padding-bottom: 10px;
    margin-bottom: 0px;
  }
  img {
    padding: 7px 7px 20px;
    max-width: 100%;
  }
  .resources-container .contact-section {
    margin-bottom: 0px;
  }
/* Publication Styles - Completely revised for horizontal layout */
.documents-section {
  margin-bottom: 10px !important; /* Override the default section margin */
}

.documents-section h2 {
  margin-top: 15px;    /* Set the top margin to 10px */
  margin-bottom: 15px; /* Maintain some space below the heading */
}

.publication-item {
  margin-bottom: 25px;
}

.publication-box {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 15px 25px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: auto; 
}

.publication-box:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.publication-content {
  display: grid;
  grid-template-columns: 40px 240px 1fr 120px;
  grid-template-areas: "left middle right action";
  align-items: center;
  gap: 15px;
}

.publication-left {
  grid-area: left;
}

.publication-middle {
  grid-area: middle;
}

.publication-right {
  grid-area: right;
}

.publication-action {
  grid-area: action;
  text-align: right;
}

.publication-action .btn {
  padding: 6px 12px;
  font-size: 0.875rem;
  white-space: nowrap;
  border-radius: 0px;
  font-weight: 700;
  transition: all 0.2s ease;
  min-width: 60px;
}

.publication-content .icon {
  max-width: 30px;
  height: auto;
  padding: 0;
  margin: 0;
}

.publication-box h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
  line-height: 1.2;
}

.publication-date {
  color: #666;
  font-size: 12px;
  margin: 5px 0 0 0;
}

.publication-description {
  margin: 0;
  line-height: 1.4;
  font-size: 14px;
}

.btn-sm {
  padding: 5px 10px;
  font-size: 0.85rem;
}
  @media (max-width: 500px) {
    .intro-section {
      background-image: url('../assets/images/background/snowy-road.jpg');
    }
  }
  @media (min-width: 501px) and (max-width: 768px) {
    .intro-section {
      background-image: url('../assets/images/background/snowy-road.jpg');
    }
  }
  @media (max-width: 549px) {
    img {
      width: 100%;
      padding: 0px 0px 10px;
    }
  }
  @media (min-width: 768px) {
    h1 {
      font-size: 3.5rem;
    }
    .details-section {
      margin-bottom: 45px;
    }
  }
  @media (max-width: 992px) {
    .contact-section .subheader::before {
      margin-top: -190px;
      height: 190px;
    }
    .eco-opt-eff-section {
      padding-bottom: 100px;
    }
  }
  @media (min-width: 992px) {
    .mobile-img {
      display: none;
    }
  }
  @media (min-width: 1200px) {
    .intro-section h1 {
      width: 85%;
    }
    .feat {
      margin-top: 60px;
    }
  }
  @media (min-width: 1281px) and (max-width: 1600px) {
    .intro-section {
      background-image: url('../assets/images/background/snowy-road.jpg');
    }
  }
  @media (min-width: 1601px) and (max-width: 2500px ) {
    .intro-section {
      background-image: url('../assets/images/background/snowy-road.jpg');
    }
  }
  @media (min-width: 2501px) {
    .intro-section {
      background-image: url('../assets/images/background/snowy-road.jpg');
    }
  }
  @media (max-width: 1200px) {
  .publication-content {
    grid-template-columns: 40px 220px 1fr 110px;
    gap: 10px;
  }
  
  .publication-box {
    padding: 12px;
  }
}

@media (max-width: 991px) {
  .publication-content {
    grid-template-columns: 40px 180px 1fr 100px;
  }
  
  .publication-description {
    font-size: 13px;
    line-height: 1.3;
  }
  
  .publication-action .btn {
    font-size: 0.8rem;
    padding: 5px 10px;
  }
}

@media (max-width: 767px) {
  .publication-box {
    height: auto;
    min-height: 120px;
  }
  
  .publication-content {
    grid-template-columns: 40px 1fr 100px;
    grid-template-rows: auto auto;
    grid-template-areas: 
      "left middle action"
      "right right right";
  }
  
  .publication-right {
    padding-top: 10px;
  }
  
  .publication-description {
    margin-top: 5px;
  }
}

@media (max-width: 575px) {
  .documents-section h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .publication-box {
    min-height: 150px;
  }
  
  .publication-content {
    grid-template-columns: 40px 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas: 
      "left middle"
      "right right"
      "action action";
    gap: 8px;
  }
  
  .publication-action {
    text-align: left;
    margin-top: 10px;
  }
  
  .publication-right {
    padding-top: 5px;
  }
  
  .publication-middle h3 {
    font-size: 18px;
  }
}

@media (max-width: 375px) {
  .publication-box {
    padding: 12px 10px;
  }
  
  .publication-content {
    grid-template-columns: 30px 1fr;
  }
  
  .publication-content .icon {
    max-width: 24px;
  }
  
  .publication-middle h3 {
    font-size: 16px;
  }
}
  </style>

  